// Türkiye'de yaygın kullanılan bankalar. Datalist için ortak referans listesi.
// Çek Koçanları ve Verilen Çek formlarında aynı liste kullanılır → yazım tutarlılığı.
// Not: Free-text girişe izin verilir (küçük/yerel bankalar için). Ancak öneriler
// autocomplete olarak açıldığı için tutarsız isimler (Garanti / Garanti BBVA) minimize edilir.
export const TR_BANKS = [
  "Akbank",
  "Albaraka Türk",
  "Alternatifbank",
  "Anadolubank",
  "Bank of China Turkey",
  "Burgan Bank",
  "Citibank",
  "Denizbank",
  "Emlak Katılım",
  "Fibabanka",
  "Garanti BBVA",
  "Halkbank",
  "HSBC",
  "ICBC Turkey",
  "ING Bank",
  "İş Bankası",
  "Kuveyt Türk",
  "Odea Bank",
  "QNB Finansbank",
  "Şekerbank",
  "TEB",
  "Türkiye Finans",
  "Vakıf Katılım",
  "VakıfBank",
  "Yapı Kredi",
  "Ziraat Bankası",
  "Ziraat Katılım",
];

// Datalist için tekil id (her sayfada bir kez render edilir)
export const BANK_DATALIST_ID = "tr-banks-list";
